import { gql } from "@apollo/client";

export const CRM_SEQUENCE = gql`
  query CrmSequence($where: CrmSequenceWhereInput) {
    crmSequence(where: $where) {
      id
      campaignId
      version
      steps {
        id
        type
        order
        parentId
        branchKey
        config
        isAutomatic
        senderOverride
      }
    }
  }
`;

const crmSequences = { CRM_SEQUENCE };
export default crmSequences;
